// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"530":"25bcda03efd80bb9e018","540":"259b8adb800b46c0f700","676":"46ba06c1de06ca5c6e21","780":"a9cbee582b797b94a329"}[chunkId] + ".chunk.js";
};